
import { createSelector } from 'reselect';
import { find } from 'lodash';

export const getUserContext = state => state.user.userContext;
// export const getIsUserGuest = state => state.user.userContext.is_guest;

export const getIsUserGuest = createSelector(
  getUserContext,
  userContext => userContext.is_guest
);

export const getWeddingInfo = (state) => {
  const userContext = state.user && state.user.userContext;
  const weddingUserRole = userContext.user_role_account_weddings
    && find(userContext.user_role_account_weddings, userRole => userRole.role === 'OWNER');

  if (weddingUserRole) {
    return {
      owner_first_name: weddingUserRole.owner_first_name,
      owner_last_name: weddingUserRole.owner_last_name,
      partner_first_name: weddingUserRole.partner_first_name,
      partner_last_name: weddingUserRole.partner_last_name,
      wedding_date: weddingUserRole.wedding_date,
    };
  }

  return null;
};



// WEBPACK FOOTER //
// ./src/selectors/authentication/User.js